"use client";

import { useStaleBuildDetection } from "@/lib/hooks/useStaleBuildDetection";

export function StaleBuildDetector() {
  useStaleBuildDetection();
  return null;
}
